/**
 * src/db/header.db.js
 *
 * Datos del header: logo, navegación y CTA.
 */

import { uiIcons } from '@/shared/brandIcons.js'

export const headerData = {
    logo: {
        src: '/logo.png',
        alt: 'UBIYAAA — Confianza, inmediatez y seguridad',
        brand: '',
        tagline: ''
    },
    navLinks: [
        { label: 'Inicio',              href: '/',               name: 'initial'    },
        { label: 'Directorio',          href: '/directorio',     name: 'directory'  },
        { label: 'Promociones',         href: '/promociones',    name: 'promos'     },
        { label: 'Contacto',            href: '/contacto',       name: 'contact'    },
        { label: 'Registrar anuncio',   href: '/registrar',      name: 'register'   },
    ],
    cta: {
        label: 'Pedir transporte',
        href:  'https://wa.me/573124288323?text=Hola%2C%20quiero%20pedir%20transporte',
        icon:  uiIcons.car
    }
}
